/*
  Tawk.to chat bubble position controller (desktop + mobile).

  Keeps the chat bubble out of the way:
    - sticky add-to-cart bar HIDDEN -> bubble sits low in the corner (LOW px)
    - sticky add-to-cart bar SHOWN  -> bubble lifts just above the bar

  Written defensively, because tawk fights back:
    - tawk renders SEVERAL fixed iframes (bubble, minimised window, greeting
      card, full-screen overlay) with random IDs and inline bottom:...!important.
      We only ever touch the small corner bubble(s); wide panels/cards/overlays
      are excluded by width.
    - tawk re-asserts its own inline bottom on scroll/interaction, so we never
      "set once". We re-apply on scroll, resize, when new iframes appear, and
      whenever tawk rewrites the bubble's style (a MutationObserver on the iframe
      wins the fight; the cur!==target check prevents an infinite loop).
    - bar visibility is read from the bar's real geometry, not a CSS class, so a
      missed class toggle can't desync us.
    - everything is wrapped in try/catch and no-ops if nothing is found; this is
      never worse than leaving tawk alone.
*/
(function () {
  try {
    var LOW = 20;            // bubble bottom (px) when the bar is hidden
    var GAP = 14;            // gap (px) between bubble and the bar when shown
    var BUBBLE_MAX_W = 100;  // only the small corner bubble (panels/cards/minimised widgets are wider)
    var html = document.documentElement;
    var mine = new WeakMap();      // iframe -> last px value WE wrote
    var watched = new WeakSet();   // iframes whose style we already observe
    var scheduled = false;

    // Small, corner-anchored, fixed iframes = the bubble (and its minimised
    // states). Wide overlays / cards / panels are excluded by width.
    function findBubbles() {
      var out = [];
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        var f = iframes[i];
        var cs = getComputedStyle(f);
        if (cs.position !== 'fixed') continue;
        if (!f.style.bottom || !f.style.right) continue;
        var w = f.style.width || '';
        if (w.indexOf('%') !== -1) continue;
        var wpx = parseInt(w, 10);
        if (isNaN(wpx) || wpx > BUBBLE_MAX_W) continue;
        out.push(f);
      }
      return out;
    }

    // Is the sticky add-to-cart bar actually visible? Geometry, not a class.
    function barShown() {
      var bar = document.querySelector('.m-sticky-addtocart');
      if (!bar) return false;
      var cs = getComputedStyle(bar);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var r = bar.getBoundingClientRect();
      return r.height > 0 && r.top < (window.innerHeight - 5);
    }

    // Desired bubble bottom (px) for the current state.
    function targetBottom() {
      if (!barShown()) return LOW;
      var bar = document.querySelector('.m-sticky-addtocart');
      var r = bar.getBoundingClientRect();
      return Math.max(Math.round(window.innerHeight - r.top) + GAP, LOW);
    }

    function watchStyle(el) {
      if (watched.has(el)) return;
      watched.add(el);
      try {
        new MutationObserver(scheduleApply)
          .observe(el, { attributes: true, attributeFilter: ['style'] });
      } catch (e) {}
    }

    function apply() {
      try {
        // Reposition on ALL viewports (desktop + mobile). targetBottom()
        // returns LOW when the bar is hidden, or just-above-bar when shown.
        var target = targetBottom();
        var bubbles = findBubbles();
        for (var i = 0; i < bubbles.length; i++) {
          var el = bubbles[i];
          watchStyle(el);
          if (!el.isConnected) continue;
          if (parseInt(el.style.bottom, 10) !== target) {  // guard: stops loop
            el.style.setProperty('bottom', target + 'px', 'important');
            mine.set(el, target);
          }
        }
      } catch (e) {}
    }

    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      var run = function () { scheduled = false; apply(); };
      if (window.requestAnimationFrame) requestAnimationFrame(run);
      else setTimeout(run, 16);
    }

    // --- triggers -----------------------------------------------------------

    // Bar shows/hides on scroll, and tawk re-asserts on scroll.
    window.addEventListener('scroll', scheduleApply, { passive: true });
    window.addEventListener('resize', scheduleApply, { passive: true });

    // Class toggle on <html> from sticky-atc.js (kept as an extra signal).
    try {
      new MutationObserver(scheduleApply)
        .observe(html, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    // tawk can inject / recreate its iframes at any time.
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleApply(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    // Hook tawk's onLoad without clobbering an existing handler.
    window.Tawk_API = window.Tawk_API || {};
    var prevOnLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = function () {
      if (typeof prevOnLoad === 'function') { try { prevOnLoad(); } catch (e) {} }
      scheduleApply();
    };

    // Safety net: re-apply on a steady tick so a missed event or a throttled
    // animation frame can never leave the bubble stuck in the wrong place.
    // apply() is idempotent (only writes when the value actually differs).
    setInterval(apply, 500);

    scheduleApply();
  } catch (e) {}
})();